import {
    ChangeDetectionStrategy,
    Component,
    inject,
    OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import { filter, take } from 'rxjs';
import { AppService } from '../../../core/services/app/app.service';
import { UserApiService } from '../../../libs/api-contract';
import { AppShellComponent } from '../app-shell/app-shell.component';

@Component({
    imports: [RouterModule, AppShellComponent, WdxSpinnerModule],
    templateUrl: './app-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppPageComponent implements OnInit {
    private readonly userApiService = inject(UserApiService);
    private readonly appService = inject(AppService);

    ngOnInit(): void {
        this.userApiService
            .getTenant()
            .pipe(
                take(1),
                filter((tenant) => Boolean(tenant)),
            )
            .subscribe((tenant) =>
                this.appService.tenantName$.next(
                    tenant[0].tenantName as string,
                ),
            );
    }
}
